import React from 'react';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Timer from '@material-ui/icons/Timer';
import TimerOff from '@material-ui/icons/TimerOff';
import Timelapse from '@material-ui/icons/Timelapse';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { CheckIcon } from '../../../../images/icons/WrapSvg';


class Index extends React.Component {
    state = {
        anchorEl: null,
        data: [],
    };

    static getDerivedStateFromProps(props, state) {
        const { data, filtro } = props;
        if (data !== state.data || filtro !== state.filtro) {
            state.data = data;
            state.filtro = filtro ? filtro : undefined;
            state.local = filtro && filtro.local ? parseInt(filtro.local, 10) : 0;
            state.estado = filtro && filtro.estado;
            state.fecha = filtro && filtro.fecha;
            return state;
        }
        return null;
    }

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleRow = (id) => {
        this.props.history.push(`/xef/forecast/${id}`);
    };

    render() {
        const { intl } = this.props;
        const { data, filtro, local, estado, fecha } = this.state;
        return (
            <Paper className={'productions_table_paper bg_ice_blue'}>
                <Table className={'productions_table_table'}>
                    <TableHead>
                        <TableRow className={'productions_table_row'}>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'production_table_name' })}
                            </TableCell>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'production_table_date' })}
                            </TableCell>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'modification_table_manager' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'production_table_forecast' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'production_table_status' })}
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data &&
                            data.length > 0 &&
                            data
                                .map((n) => {
                                    if (!filtro ||
                                        ((!local || local === n.idLocal)
                                            && (!estado || (estado === "1" && !!n.aceptado) || (estado === "3" && !!n.caducado) || (estado === "4" && !n.aceptado))
                                            && (!fecha || (n.fecha.split(' ') && fecha.toString() === n.fecha.split(' ')[0])))) {
                                        console.log(n.idLocal, !!n.aceptado, !!n.caducado, local, estado, n)
                                        return (
                                            <TableRow
                                                hover
                                                key={`forecast-id-${n.id}`}
                                                className={'productions_table_row hand'}
                                                classes={{ hover: 'productions_table_hover' }}
                                                onClick={() => this.handleRow(n.id)}
                                            >
                                                <TableCell
                                                    className={
                                                        'barlow_regular_small c_dark_grey_blue nowrap'
                                                    }
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {n.nLocal}
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        'barlow_regular_small c_dark_grey_blue nowrap'
                                                    }
                                                >
                                                    {n.creado && n.creado}
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        'barlow_regular_small c_dark_grey_blue nowrap'
                                                    }
                                                >
                                                    {n.nAceptadoPor}
                                                </TableCell>
                                                <TableCell
                                                    align="right"
                                                    className={
                                                        'barlow_semibold_small c_dark_grey_blue nowrap'
                                                    }
                                                >
                                                    {n.ventadia ? n.ventadia + ' €' : ' €'}
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        'barlow_regular_small c_dark_grey_blue center nowrap '
                                                    }
                                                >
                                                    {n.aceptado && <CheckIcon className="c_pea margin_top_6" />}
                                                    {!n.aceptado && n.propuesta && (
                                                        <Timer className="c_golden_yellow margin_top_6" />
                                                    )}
                                                    {!n.aceptado && !n.propuesta && !n.caducado && (
                                                        <Timelapse className="c_golden_yellow margin_top_6" />
                                                    )}
                                                    {!n.aceptado && !n.propuesta && n.caducado && (
                                                        <TimerOff className="c_cool_grey_two margin_top_6" />
                                                    )}
                                                </TableCell>

                                                <TableCell className={'productions_table_dots'}>
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        aria-label="add"
                                                        className={'productions_table_button'}
                                                        onClick={(e) => this.handleClick(e)}
                                                    >
                                                        <ChevronRight />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }
                                    else {
                                        return null;
                                    }

                                })}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecasts/Table.js